export default __webpack_public_path__ + "static/media/iconExcelNovo.0663d2cc.svg";